import React, {Fragment, useEffect, useState} from 'react';
import MessageBroker from '@bonprix/pattern-library/components/message-broker';
import ProductMessages from './message-list';

export default function SubmitError({className}) {
    const [error, setError] = useState(null);

    const initialize = () => {
        const subscriptions = [
            MessageBroker.subscribe(ProductMessages.SHOW_SUBMIT_ERROR, ({error}) => setError(error)),
            MessageBroker.subscribe(ProductMessages.HIDE_SUBMIT_ERROR, () => setError(null)),
        ];
        return () => {
            subscriptions.forEach(MessageBroker.unsubscribe);
        };
    };

    useEffect(initialize, []);

    return <>{error && <div className={className}>{error}</div>}</>;
}
